module.exports = __webpack_public_path__ + "img/1440.cc001642.jpg";